// The server clock is the only source of elapsed time. Nothing is kept in local storage, so a
// refresh, a second tab and a re-login all restore the same value from `started_at`.
//
// A client clock running behind the server would otherwise yield a negative elapsed time and
// render as a count-up from a bogus value, hence the floor at zero.
export const computeElapsedSeconds = (startedAt: string, nowMs: number): number => {
    const startedAtMs = Date.parse(startedAt);

    if (!Number.isFinite(startedAtMs) || !Number.isFinite(nowMs)) {
        return 0;
    }

    return Math.max(0, Math.floor((nowMs - startedAtMs) / 1000));
};
